import { isRejectedWithValue } from '@reduxjs/toolkit';

import { API_BASE_URL } from 'shared/config/url';
import { HttpStatusCode } from 'shared/types';
import { redirectTo } from 'shared/utils/router';

import type { Middleware } from '@reduxjs/toolkit';

export const rtkQueryAuthErrorLogger: Middleware = () => next => action => {
  if (isRejectedWithValue(action)) {
    const { payload: error } = action;

    if (error?.status === HttpStatusCode.Unauthorized) {
      return redirectTo(
        `${API_BASE_URL}/auth/signin?redirectUrl=${document.URL}`,
      );
    }
  }

  return next(action);
};
